module.exports = __webpack_public_path__ + "static/media/ico-close.859f01e4.svg";